(ns app.front.ui.config-pills
  (:require [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag]]
            [clojure.set :as set]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [reagent.core :as r]))

(def pill
  :span.px-3.py-2.font-bold.text-ui-white.text-xs.text-center.rounded-full.whitespace-nowrap.h-9.w-auto.inline-flex.items-center)

(defn removable-pill [{:keys [on-remove tr]} content]
  [pill {:class "bg-ui-night-sky-100"}
   content
   (when on-remove
     [:button.bg-transparent.border-0 {:type     :button
                                       :on-click on-remove}
      (cc/icon {:icon        i/remove
                :height      "10px"
                :fill        "white"
                :description (tr [:remove])
                :class-name  "cursor-pointer pl-2"})])])

(defn add-cancel-buttons [{:keys [tr on-add on-cancel disabled?]}]
  [:<>
   (cc/button
     {:kind             :ghost
      :icon-position    :right
      :icon-description (tr [:cancel])
      :size             :field
      :icon             i/remove
      :on-click         on-cancel
      :data-cy          "cancel-icon-button"}
     (tr [:cancel]))
   (cc/button
     {:kind             :ghost
      :icon-position    :right
      :icon-description (tr [:add])
      :size             :field
      :icon             i/check
      :disabled         disabled?
      :on-click         on-add
      :data-cy          "add-icon-button"}
     (tr [:add]))])

(defn add-component [{:keys [id available-values val->str add-item on-select add-button-text tr]}]
  (r/with-let [*select (r/atom {:selecting? false})]
    (when (seq available-values)
      (if (:selecting? @*select)
        [:div.flex.max-w-xl
         [ui-select/select (util/mmap {:id           (str id "-select")
                                       :class-name   "full-width-select"
                                       :allow-empty? false
                                       :value        (:value @*select)
                                       :on-change    (fn [value]
                                                       (swap! *select assoc :value value)
                                                       (when on-select (on-select value)))
                                       :values       available-values}
                                      val->str tr)]
         [add-cancel-buttons
          (util/mmap {:on-add    (fn [_]
                                   (add-item (:value @*select))
                                   (reset! *select {:selecting? false})
                                   (when on-select (on-select nil)))
                      :on-cancel (fn [_]
                                   (swap! *select assoc :selecting? false)
                                   (when on-select
                                     (swap! *select assoc :value nil)
                                     (on-select nil)))
                      :disabled? (-> @*select :value nil?)}
                     tr)]]
        [:div.flex-initial
         (cc/button
           {:size     :field
            :icon     i/plus
            :kind     :tertiary
            :data-cy  "add-button"
            :on-click #(swap! *select assoc :selecting? true)}
           (or add-button-text (tr [:add])))]))))

(defn config-pills [{:keys [legend-text
                            empty-placeholder
                            add-button-text
                            pre-selected
                            selected
                            values
                            loading?
                            val->str
                            val->id
                            remove-item
                            add-item
                            on-select
                            tr
                            id
                            required?]
                     :or   {legend-text ""
                            val->str    identity
                            val->id     identity}}]
  [:fieldset {:class "bx--fieldset" :data-cy id}
   (when legend-text
     [:label.bx--label (when required? {:class "required-field"}) legend-text])
   (when (and (empty? values)
              empty-placeholder)
     [:p (tr [empty-placeholder])])
   (when (or (seq pre-selected) (seq selected))
     [:div.flex.flex-wrap.gap-2 {:class (when add-item "mb-2")}
      (for-frag [item pre-selected]
        [pill {:class "bg-gray-300" :aria-disabled true}
         (val->str item)])
      (for-frag [item selected]
        [removable-pill
         (-> (util/mmap tr)
             (p/assoc-if :on-remove (when remove-item #(remove-item item))))
         (val->str item)])])
   (when loading?
     [:div.inline-block
      (cc/loading-spinner {:small true :with-overlay false})])
   (when add-item
     [add-component (util/mmap {:available-values (remove (fn [v] ((set/union (set (map val->id pre-selected))
                                                                              (set (map val->id selected)))
                                                                   (val->id v)))
                                                          values)}
                               id val->str add-item on-select add-button-text tr)])])
